import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button, ButtonVariant } from "@withfriendsco/wf-components";
import { useMutation, gql } from '@apollo/client';
import { UPDATE_SQUARESPACE_SHOP } from '../wf/queries';
const ConnectSquarespace = ({ callback, businessId }) => {
    const [storeName, setStoreName] = useState("");
    const [buttonText, setButtonText] = useState("Connect Your Squarespace Shop");
    const [updateSquarespaceShop] = useMutation(UPDATE_SQUARESPACE_SHOP, {
        variables: {
            id: businessId,
            squarespaceShop: storeName,
        },
        update: (cache, { data }) => {
            var _a;
            const squarespaceShop = (_a = data === null || data === void 0 ? void 0 : data.updateBusiness) === null || _a === void 0 ? void 0 : _a.squarespaceShop;
            cache.writeFragment({
                fragment: gql `
          fragment UpdateSquarespaceShop on Business {
            squarespaceShop
          }
        `,
                data: {
                    __typename: "Business",
                    id: businessId,
                    squarespaceShop,
                }
            });
        }
    });
    const handleStoreNameChange = (ev) => {
        setStoreName(ev.target.value);
    };
    const sendUpdate = async () => {
        setButtonText("Shop name sent!");
        await updateSquarespaceShop();
        callback(false);
    };
    return (_jsxs("div", { className: "text-center", children: [_jsx("label", { className: "text-xl my-4 block", htmlFor: "squarespaceStore", children: "What is your full Squarespace Store URL?" }), _jsx("input", { type: "text", name: "squarespaceStore", value: storeName, onChange: handleStoreNameChange, className: `block w-full border border-gray-300 p-2 text-center`, placeholder: "http://your-full-squarespace-store.com" }), _jsx(Button, { className: "my-2", variant: ButtonVariant.Outlined, onClick: sendUpdate, children: buttonText })] }));
};
export default ConnectSquarespace;
